export default "__VITE_ASSET__d20ba9b1__"